import { ca } from '@cian/analytics';

import { ITracking } from '../../types/tracking';

export const trackClickContent = (label: string, products: ITracking['products']) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'CardCompany',
    label,
    products,
  });
};

export const trackClickRating = (products: ITracking['products']) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'CardCompany',
    label: 'rating',
    products,
  });
};
